export class Template {
    constructor(public iceSupplier?: string,
                public content?: string,
                public supplierName?: string,
                public fiscalId?: string,
                public vatIdNumber?: string,
                public id?: number) {
    }
}
